import { definitions } from '@luxuryescapes/contract-business'

type ServerAccountSummary = NonNullable<definitions['accountReadByCustomerIdResponseSchema']['accountSummary']>

function mapLoyaltyLinkedCreditAccount(response: ServerAccountSummary | null): App.LoyaltyLinkedCreditAccount | null {
  if (!response) return null

  return {
    tier: response.tier,
  }
}

export default mapLoyaltyLinkedCreditAccount
